import { gql } from 'apollo-angular';

export const ADD_ADDITIONAL_COST = gql`
  mutation AdditionalCostCreate($data: AdditionalCostCreateInput!, $totalAmount: Float) {
    AdditionalCostCreate(data: $data, totalAmount: $totalAmount) {
      id
      type
      description
      value
      supplierReference
      internalNote
      freightId
      basisAmount
      basisQuantityTypeId
      totalAmount
      freight {
        id
        company {
          id
          name
        }
        originPort {
          id
          name
        }
        destinyPort {
          id
          name
          country {
            id
            name
          }
        }
        via
        tt
      }
    }
  }
`;

export const DELETE_ADDITIONAL_COST = gql`
  mutation AdditionalCostDelete($where: AdditionalCostWhereUniqueInput!) {
    AdditionalCostDelete(where: $where) {
      id
    }
  }
`;

export const UPDATE_ADDITIONAL_COST = gql`
  mutation AdditionalCostUpdate(
    $where: AdditionalCostWhereUniqueInput!
    $data: AdditionalCostUpdateInput!
  ) {
    AdditionalCostUpdate(where: $where, data: $data) {
      id
      type
      description
      value
      supplierReference
      internalNote
      freightId
      basisAmount
      basisQuantityTypeId
      totalAmount
      freight {
        id
        company {
          id
          name
        }
        originPort {
          id
          name
        }
        destinyPort {
          id
          name
          country {
            id
            name
          }
        }
        via
        tt
      }
    }
  }
`;
